// Account API
import ajax from './_ajax';

const api = {};
api.inquiryPriceDownload = function () {
  return ajax.get('/api/InquiryPrice/Download');
};
api.inquiryPriceUpload = function (params) {
  return ajax.post('/api/InquiryPrice/Upload', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/inquiryPriceApi.js